import { colorsCalculator } from "../../helpers/math";

export const blueColor = colorsCalculator({
    hex: "#567fbf",
    rgb: { a: 1, b: 191, g: 127, r: 96 }
    
});

export const greenColor = colorsCalculator({
    hex: "#009688",
    rgb: {a: 1, b: 126, g: 150, r: 0}
});

export const blueColor_two = {
    bg: "rgb(73, 163, 241)",
    bg_degraded: " rgb(26, 115, 232)"
};